module.exports = __webpack_public_path__ + "img/lichen.9918beaf.jpg";